export const MACHINE_CREATE_SUCCESS = 'Machine {0} has been created';
export const MACHINE_CREATE_ERROR = 'Error while creating machine';
export const MACHINE_NAME_IS_REQUIRED = 'Machine name is required';
export const MACHINE_TYPE = 'Machine Type';
export const MACHINE_TYPE_IS_REQUIRED = 'Machine type is required';
export const CLASSIC = 'CLASSIC';
export const CLOSE = 'Close';
export const ADD_MACHINE = 'Add Machine';
export const MACHINE_NAME = 'Machine Name';
export const MACHINE_CATEGORY = 'Machine Category';
export const REALM_TYPE ={
     'APPLICATION': 'APPLICATION',
     'CUSTOMER': 'CUSTOMER'
};
export const MIGRATION_STATUS = {
     CLASSIC: 'CLASSIC',
     IN_PROGRESS: 'IN_PROGRESS',
     PREPARED: 'PREPARED',
     DUAL: 'DUAL',
     MODERN: 'MODERN',
     FAILED: 'FAILED'
};
